// events/eventTypes.ts

import { Comment, Note, Topic } from '@/types'

export const AppEvents = {
  REFETCH_REQUESTS: 'refetch-requests',
  REFETCH_CONNECTIONS: 'refetch-connections',
  TOPIC_ADDED: 'TOPIC_ADDED',
  TOPIC_UPDATED: 'TOPIC_UPDATED',
  TOPIC_DELETED: 'TOPIC_DELETED',
  TOPIC_VIEWED: 'TOPIC_VIEWED',
  TOPIC_PRIVACY_UPDATED: 'TOPIC_PRIVACY_UPDATED',
  TOPIC_NAME_UPDATED: 'TOPIC_NAME_UPDATED',
  TOPIC_NOTE_ADDED: 'TOPIC_NOTE_ADDED',
  TOPIC_NOTE_UPDATED: 'TOPIC_NOTE_UPDATED',
  TOPIC_NOTE_DELETED: 'TOPIC_NOTE_DELETED',
  NOTE_LIKE_STATUS_UPDATED: 'NOTE_LIKE_STATUS_UPDATED',
  NOTE_COMMENT_ADDED: 'NOTE_COMMENT_ADDED',
  NOTE_COMMENT_DELETED: 'NOTE_COMMENT_DELETED',
} as const

export type AppEventName = (typeof AppEvents)[keyof typeof AppEvents]

export interface AppEventPayloadMap {
  [AppEvents.REFETCH_REQUESTS]: undefined
  [AppEvents.REFETCH_CONNECTIONS]: undefined
  [AppEvents.TOPIC_ADDED]: { topic: Topic }
  [AppEvents.TOPIC_UPDATED]: { topic: Topic }
  [AppEvents.TOPIC_DELETED]: { topicID: string }
  [AppEvents.TOPIC_VIEWED]: { topicID: string }
  [AppEvents.TOPIC_PRIVACY_UPDATED]: { topic: Topic }
  [AppEvents.TOPIC_NAME_UPDATED]: { topicID: string; topicName: string }
  [AppEvents.TOPIC_NOTE_ADDED]: { topicID: string; note: Note }
  [AppEvents.TOPIC_NOTE_UPDATED]: { topicID: string; note: Note }
  [AppEvents.TOPIC_NOTE_DELETED]: { topicID: string; noteID: string }
  [AppEvents.NOTE_LIKE_STATUS_UPDATED]: { topicID: string; noteID: string; isLiked: boolean }
  [AppEvents.NOTE_COMMENT_ADDED]: { topicID: string; noteID: string; comment: Comment }
  [AppEvents.NOTE_COMMENT_DELETED]: { topicID: string; noteID: string; commentID: string }
}
